import { initFileInputs } from "./file-inputs.js";
import { initFormSubmitLock } from "./form-submit-lock.js";
import { initFormChoiceClickableItems } from "./form-choice-clickable-items.js";
import { initMenu } from "./menu.js";
import { initAllAnimations } from "./animations.js";
import { initPageTransitions } from "./page-transition.js";
import { initHashScroll } from "./scroll-to-hash.js";

let pageTransitionsInitialized = false;

//Prevent page transitions to not complete if an error occurs
try {
  initMenu();
  initFileInputs();
  initFormSubmitLock();
  initFormChoiceClickableItems();
  initPageTransitions();
  pageTransitionsInitialized = true;
  initHashScroll();
  initAllAnimations();
} catch (error) {
  console.error("[theme-interne] init failed", error);

  if (!pageTransitionsInitialized) {
    initPageTransitions();
  }
}
